// @flow

export const CopyRight = "Copyright ©️" + new Date().getFullYear() + ", by Vix Vizion Pty Ltd. All Rights Reserved.";
